import { IConfigStorage } from "../../../Common/IConfigStorage";
import { DataUtilities } from "../../../Common/DataUtilities";
import { IDesignValidationProvider, ValidationIssue } from "../../../Common/IDesignValidationProvider";
import { DataTypes } from "../../../Common/Data/DataTypes";

export class TableColumn implements IConfigStorage, IDesignValidationProvider {
    _id: string = DataUtilities.generateUniqueId();

    // this is auto generated as ruleCol1, ruleCol2, resultCol1... but can be changed via action
    name: string = "";

    // required for result column
    dataType?: DataTypes;

    getDesignValidationIssues(): ValidationIssue[] {
        if (this.name === "") {
            return [new ValidationIssue("result name is required")];
        }
        return [];
    }

    getStorageData(): object {
        let data = {};
        Reflect.set(data, "_id", this._id);
        Reflect.set(data, "name", this.name);
        Reflect.set(data, "dataType", this.dataType);
        return data;
    }

    setStorageData(data: object): void {
        this._id = Reflect.get(data, "_id");
        this.name = Reflect.get(data, "name");
        this.dataType = Reflect.get(data, "dataType");
    }
}
